@use '~@frontrow/console/css/variables.scss';

.sisIdDataTable {
  margin: variables.$std-margin-xlg;
}

.districtSearchContainer {
  display: flex;
  align-items: center;
}

.districtTitle {
  padding-left: variables.$std-padding-xlg;
}

.errorMsg {
  color: #a94442;
}
